import { Fragment, useEffect, useRef, useState } from "react";

import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { ExportPdfTemplate } from "./exportPdfTemplate";
import ReactDOMServer from "react-dom/server";
import { Dropdown } from "bootstrap";

export const ExportFileContainer = ({ prd }) => {
  const [prodDetail, setProdDetail] = useState(null);
  const [showHeader, setShowHeader] = useState(true);
  const [showPrice, setShowPrice] = useState(true);
  const { getProductData, exportHtml2pdfFile } = useGlobalFunction();
  const excludeTechnical = ["WagnereBook", "WESeBook", "PROD_CODE"];
  const printRef = useRef();
  const drpRef = useRef();
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    if (prd) {
      setProdDetail(prd);
    }
  }, [prd]);

  const handleDownloadPdf = async () => {
    try {
      setIsClicked(true);
      let response = await getProductData(prodDetail.productId, prodDetail.familyId);
      if (response) {
        if (response.productCard && response.productCard.technicalData) {
          let techstr = response.productCard.technicalData;
          let data = JSON.parse(techstr);
          let filtereddata = data.filter(
            (item) => !excludeTechnical.some((keyword) => item.Attr_Name.includes(keyword)),
          );
          filtereddata.push({
            Attr_Id: 450,
            Attr_Name: "SKU",
            Attr_Value: prodDetail.productCode,
            DisplayName: "Product Code",
            SORT_ORDER: 1,
          });
          const sorted = filtereddata.sort((a, b) => b.SORT_ORDER - a.SORT_ORDER);
          const mid = Math.ceil(sorted.length / 2);
          let leftData = sorted.slice(0, mid);
          let rightData = sorted.slice(mid);
          response.technicalLeftData = leftData;
          response.technicalRightData = rightData;
        }
        let htmlString = ReactDOMServer.renderToString(
          <ExportPdfTemplate pdfData={response} showPrice={showPrice} showHeader={showHeader} />,
        );
        let pdffiles = await exportHtml2pdfFile(htmlString);
        if (pdffiles) {
          const base64 = pdffiles.base64;
          const linkSource = `data:application/pdf;base64,${base64}`;
          const downloadLink = document.createElement("a");
          downloadLink.href = linkSource;
          downloadLink.download =
            (response.productCard.productName ? response.productCard.productName.trim() : prodDetail.productCode) +
            ".pdf";
          downloadLink.click();
          closeDropdown();
        }
      }
    } catch (error) {
      console.error("PDF Generation Error:", error);
    } finally {
      setIsClicked(false);
    }
  };
  const closeDropdown = () => {
    const dropdownElement = drpRef.current ?? document.getElementById("proPDF" + prodDetail.productId);
    if (dropdownElement) {
      const dropdown = Dropdown.getInstance(dropdownElement);
      if (dropdown) {
        dropdown.hide();
      }
    }
  };

  return (
    <Fragment>
      {prodDetail && (
        <div className="dropdown proList-dropdown" key={prodDetail.productId}>
          <div
            ref={drpRef}
            className="dropdown-toggle wes-printer"
            id={"proPDF" + prodDetail.productId}
            data-bs-toggle="dropdown"
            aria-expanded="false"
            data-bs-auto-close="outside"
          />
          <div className="dropdown-menu dropdown-menu-lg-end" aria-labelledby={"proPDF" + prodDetail.productId}>
            {/* Dropdown inside content */}
            <div>
              <div ref={printRef} style={{ padding: "20px", background: "#fff", display: "none" }}>
                <h2>This content will be in the PDF</h2>
                <p>You can style this container however you want.</p>
              </div>
            </div>
            <div className="proList-dropdown-info">
              <h5>Generate PDF Product Page</h5>
              <div className="proList-dropdown-content">
                <h6>PDF Printing Options</h6>
                {/* PDF List */}
                <div className="wishlist-created pdfGenerate">
                  <div className="pdf-printing-list common-radio-selection">
                    <div>
                      <input
                        className="form-check-input"
                        type="radio"
                        name={`generatePdf-${prodDetail.productId}`}
                        id={`pdfPrice-${prodDetail.productId}`}
                        checked={showPrice == true ? "checked" : ""}
                        onChange={() => {
                          setShowPrice(!showPrice);
                        }}
                      />
                    </div>
                    <label className="form-check-label" htmlFor={`pdfPrice-${prodDetail.productId}`}>
                      Show with Price
                    </label>
                  </div>
                  <div className="pdf-printing-list common-radio-selection">
                    <div>
                      <input
                        className="form-check-input"
                        type="radio"
                        name={`displayWes-${prodDetail.productId}`}
                        id={`displayWes-${prodDetail.productId}`}
                        checked={showHeader == true ? "checked" : ""}
                        onChange={() => {
                          setShowHeader(!showHeader);
                        }}
                      />
                    </div>
                    <label className="form-check-label" htmlFor={`displayWes-${prodDetail.productId}`}>
                      Display WES Details
                    </label>
                  </div>
                </div>
                {/* PDF List */}
                {/* PDF List Button */}
                <div className="pdf-button">
                  <div className="button-effect">
                    <button
                      type="submit"
                      onClick={handleDownloadPdf}
                      className="btn btn-products btn-addcart"
                      disabled={isClicked ? "disabled" : ""}
                    >
                      {isClicked ? (
                        <p>
                          <i className="fas fa-spinner fa-spin"></i>Creating PDF...
                        </p>
                      ) : (
                        "Create PDF"
                      )}
                    </button>
                  </div>
                </div>
                {/* PDF List Button */}
              </div>
            </div>
            {/* Dropdown inside content */}
          </div>
        </div>
      )}
    </Fragment>
  );
};
